const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  // Result statuses
  pending: { bg: '#fef3c7', color: '#92400e' },
  in_progress: { bg: '#dbeafe', color: '#1e40af' },
  resulted: { bg: '#e0e7ff', color: '#3730a3' },
  verified: { bg: '#d1fae5', color: '#065f46' },
  pending_release: { bg: '#ede9fe', color: '#5b21b6' },
  released: { bg: '#dcfce7', color: '#16a34a' },
  canceled: { bg: '#f1f5f9', color: '#64748b' },
  // Order statuses
  draft: { bg: '#f1f5f9', color: '#64748b' },
  submitted: { bg: '#fef3c7', color: '#92400e' },
  received: { bg: '#dbeafe', color: '#1e40af' },
  completed: { bg: '#dcfce7', color: '#16a34a' },
  // Device statuses
  active: { bg: '#dcfce7', color: '#16a34a' },
  inactive: { bg: '#f1f5f9', color: '#64748b' },
  maintenance: { bg: '#fef3c7', color: '#92400e' },
  retired: { bg: '#fee2e2', color: '#dc2626' },
  // User statuses
  suspended: { bg: '#fee2e2', color: '#dc2626' },
  // Fleet + license + alerts
  expired: { bg: '#fee2e2', color: '#dc2626' },
  warning: { bg: '#fef3c7', color: '#92400e' },
  critical: { bg: '#fee2e2', color: '#dc2626' },
  acknowledged: { bg: '#dbeafe', color: '#1e40af' },
  resolved: { bg: '#dcfce7', color: '#16a34a' },
  revoked: { bg: '#fee2e2', color: '#dc2626' },
  unknown: { bg: '#f1f5f9', color: '#64748b' },
  online: { bg: '#dcfce7', color: '#16a34a' },
  stale: { bg: '#fef3c7', color: '#92400e' },
  offline: { bg: '#fee2e2', color: '#dc2626' },
  // Generic
  enabled: { bg: '#dcfce7', color: '#16a34a' },
  disabled: { bg: '#f1f5f9', color: '#64748b' },
  // CDPH report queue statuses (pending/error/critical reuse the maps above)
  sent: { bg: '#dbeafe', color: '#1e40af' },
  accepted: { bg: '#dcfce7', color: '#16a34a' },
  rejected: { bg: '#fee2e2', color: '#dc2626' },
  error: { bg: '#fee2e2', color: '#dc2626' },
  exhausted: { bg: '#f1f5f9', color: '#64748b' },
  // Priority
  stat: { bg: '#fee2e2', color: '#dc2626' },
  routine: { bg: '#f1f5f9', color: '#64748b' },
  asap: { bg: '#fef3c7', color: '#92400e' },
  // PLAN.md §7.6.24 Slice 4 -- instrument observation dispositions.
  matched: { bg: '#dcfce7', color: '#16a34a' },
  matched_late: { bg: '#fef3c7', color: '#92400e' },
  extra_analyte: { bg: '#f1f5f9', color: '#64748b' },
  duplicate: { bg: '#f1f5f9', color: '#64748b' },
  // PLAN.md §7.6.24 Slice 3 -- panel completion badge.
  panel_complete: { bg: '#dcfce7', color: '#16a34a' },
  panel_incomplete: { bg: '#fef3c7', color: '#92400e' },
  // Release-history modal (#236) -- "Current" version badge.
  current: { bg: '#dcfce7', color: '#16a34a' },
}

const DEFAULT_COLORS = { bg: '#f1f5f9', color: '#64748b' }

interface StatusBadgeProps {
  readonly status: string
  readonly label?: string
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const { bg, color } = STATUS_COLORS[status] ?? DEFAULT_COLORS
  return (
    <span
      style={{
        padding: '0.2rem 0.6rem',
        borderRadius: '9999px',
        fontSize: '0.8125rem',
        fontWeight: 500,
        background: bg,
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {label ?? status.replace(/_/g, ' ')}
    </span>
  )
}
